import React from 'react'
import tw from 'tailwind-styled-components'

export interface TableCellProps {
  children: React.ReactNode
  width?: number | string
  minWidth?: number | string
  maxWidth?: number | string
  className?: string
  hideOnDrag?: boolean
}

const TwTableCell = tw.div<{$hideOnDrag?: boolean}>`
  flex
  overflow-hidden
  text-ellipsis

  ${p => p.$hideOnDrag && 'hide-on-drag'}
`

interface Style {
  width?: number | string
  minWidth?: number | string
  maxWidth?: number | string
}

export const TableCell = ({
  children,
  width,
  minWidth,
  maxWidth,
  className,
  hideOnDrag
}: TableCellProps) => {
  const style: Style = {}

  if (width) {
    style.width = width
  }
  if (minWidth) {
    style.minWidth = minWidth
  }
  if (maxWidth) {
    style.maxWidth = maxWidth
  }

  return (
    <TwTableCell style={style} className={className} $hideOnDrag={hideOnDrag}>
      {children}
    </TwTableCell>
  )
}
